export default __webpack_public_path__ + "static/media/kitchen3-afterC-1024w.856af4d7.webp";